@if (displayBackdrop) {
  <div class="backdrop"></div>
}
<div class="left-side-menu" (mouseenter)="isHovered = true" (mouseleave)="disableHover()">
  <!-- Fixed top section -->
  <div class="top-section">
    <div class="logo-container">
      <div class="logo">
        <a routerLink="/app" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <svg width="376" height="170" viewBox="0 0 376 176">
            <path
              class="letter b"
              d="M 0 165.85 L 60.61 165.85 C 75.24 165.85 87.02 161.1 94.62 152.93 A 35.979 35.979 0 0 0 103.838 134.441 A 42.294 42.294 0 0 0 104.5 126.9 A 34.424 34.424 0 0 0 101.778 113.062 A 34.225 34.225 0 0 0 77.14 94.03 L 77.14 93.46 C 88.751 89.862 96.562 82.464 98.512 70.902 A 35.692 35.692 0 0 0 98.99 64.96 C 98.99 55.27 95.76 47.48 90.25 41.78 A 36.175 36.175 0 0 0 72.715 31.762 C 68.889 30.765 64.7 30.196 60.141 30.043 A 76.49 76.49 0 0 0 57.57 30 L 0 30 L 0 165.85 Z M 17.1 150.46 L 17.1 102.58 L 58.71 102.58 A 37.588 37.588 0 0 1 72.186 104.854 C 80.059 107.883 85.486 113.944 86.865 123.078 A 31.951 31.951 0 0 1 87.21 127.85 A 24.175 24.175 0 0 1 86.05 135.403 A 21.564 21.564 0 0 1 81.13 143.62 C 76.57 147.99 69.54 150.46 59.85 150.46 L 17.1 150.46 Z M 17.1 88.14 L 17.1 44.82 L 57.76 44.82 C 72.96 44.82 81.89 52.8 81.89 65.91 A 22.735 22.735 0 0 1 79.363 76.813 C 75.663 83.684 68.042 87.668 57.44 88.101 A 48.054 48.054 0 0 1 55.48 88.14 L 17.1 88.14 Z"
              fill="black"
            ></path>
            <path
              class="letter r"
              d="M142.021 79.72H142.421C148.6 69.5994 159.344 61.0956 173.086 61.0956C176.072 61.0956 177.663 61.5029 179.654 62.3052V78.0909H179.059C176.667 77.2763 175.077 77.0788 171.884 77.0788C155.957 77.0788 142.021 89.2235 142.021 108.86V166.955H125.887V62.3175H142.021V79.7324V79.72Z"
              fill="black"
            ></path>
            <path class="letter i" d="M210.378 62.3175H194.245V166.979H210.378V62.3175Z" fill="black"></path>
            <path
              class="letter e"
              d="M226.55 114.747C226.55 84.3853 246.058 59.6886 275.327 59.6886C306.186 59.6886 322.72 83.978 322.72 118.598H243.072C244.274 139.851 255.612 156.044 276.322 156.044C291.254 156.044 301.208 148.762 304.79 134.581H320.522C315.739 157.056 299.618 169.806 276.322 169.806C244.856 169.806 226.55 145.109 226.55 114.747ZM243.472 106.243H305.397C304.401 85.3974 293.852 72.6355 275.327 72.6355C256.802 72.6355 245.864 87.2117 243.472 106.243Z"
              fill="black"
            ></path>
            <path
              class="letter f"
              d="M340.552 45.2729C340.552 27.2533 350.7 20.7736 367.829 20.7736C371.216 20.7736 373.802 20.9711 375.999 21.1809V35.1523C373.207 34.9548 372.418 34.9548 370.828 34.9548C360.473 34.9548 356.685 37.5837 356.685 46.0875V62.083H375.805V75.4496H356.685V134.273H340.552V45.2729Z"
              fill="black"
            ></path>
          </svg>
        </a>
      </div>
      @if (isExpanded) {
        <div class="toggle-container clickable" (click)="toggleExpansion()">
          <mat-icon [matTooltip]="(isPermanentlyExpanded ? 'SETTINGS.HIDE_SIDEBAR' : 'SETTINGS.EXPAND_SIDEBAR') | translate" fontSet="material-symbols-outlined"
            >{{ isPermanentlyExpanded ? 'left_panel_close' : 'left_panel_open' }}
          </mat-icon>
        </div>
      }
    </div>
    <mat-divider class="spaced"></mat-divider>
  </div>

  <!-- Scrollable middle section -->
  <div class="middle-section">
    <a [routerLink]="[]" [queryParams]="{ isSearchOpen: true, demoProfileId: activeDemoProfile$ | async }">
      <div class="navigation-item">
        <mat-icon class="icon" fontIcon="search"></mat-icon>
        <div class="label">{{ 'COMMON.SEARCH' | translate }}</div>
      </div>
    </a>
    <a [routerLink]="['/app', 'meetings']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
      <div class="navigation-item" (click)="disableHover()">
        <mat-icon class="icon" fontIcon="phone"></mat-icon>
        <div class="label">{{ 'COMMON.CALLS' | translate }}</div>
        @if (isExpanded) {
          <mat-icon class="icon right" [fontIcon]="isCallsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"></mat-icon>
        }
      </div>
    </a>

    @if (isCallsExpanded) {
      <div class="nested-panel">
        <a [routerLink]="['/app', 'meetings', 'past']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
            <div class="label">{{ 'COMMON.PAST' | translate }}</div>
          </div>
        </a>
        <a [routerLink]="['/app', 'meetings', 'shared-with-me']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
            <div class="label">{{ 'COMMON.SHARED_WITH_ME' | translate }}</div>
          </div>
        </a>
      </div>
    }
    @if (displayImportCallButton) {
      <a [routerLink]="['/app', 'import']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
        <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
          <mat-icon class="icon" fontIcon="upload"></mat-icon>
          <div class="label">{{ 'COMMON.UPLOAD_CALL' | translate }}</div>
        </div>
      </a>
    }

    @if (displayAddCallButton) {
      <a [routerLink]="['/app', 'meetings', 'new']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
        <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
          <mat-icon class="icon" fontIcon="add_call"></mat-icon>
          <div class="label">{{ 'CALLS.ADD_CALL.TITLE' | translate }}</div>
        </div>
      </a>
    }
    <mat-divider class="spaced"></mat-divider>

    @if (displayAdminSection) {
      <a [routerLink]="['/app', 'admin', 'dashboard']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
        <div class="navigation-item clickable">
          <mat-icon class="icon" fontIcon="admin_panel_settings"></mat-icon>
          <div class="label">{{ 'COMMON.ADMIN' | translate }}</div>
          @if (isExpanded) {
            <mat-icon class="icon right" [fontIcon]="isAdminExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"></mat-icon>
          }
        </div>
      </a>

      @if (isAdminExpanded) {
        <div class="nested-panel">
          <a [routerLink]="['/app', 'admin', 'dashboard']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'COMMON.DASHBOARD' | translate }}</div>
            </div>
          </a>
          <a [routerLink]="['/app', 'admin', 'activity-log']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'ACTIVITY_LOG.TITLE' | translate }}</div>
            </div>
          </a>
        </div>
      }
    }

    <a
      [routerLink]="['/app', 'settings', 'language']"
      [queryParams]="{
        demoProfileId: activeDemoProfile$ | async,
      }"
    >
      <div class="navigation-item clickable">
        <mat-icon class="icon" fontIcon="settings"></mat-icon>
        <div class="label">{{ 'COMMON.SETTINGS' | translate }}</div>
        @if (isExpanded) {
          <mat-icon class="icon right" [fontIcon]="isSettingsExpanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'"></mat-icon>
        }
      </div>
    </a>

    @if (isSettingsExpanded) {
      <div class="nested-panel">
        <a [routerLink]="['/app', 'settings', 'language']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
            <div class="label">{{ 'SETTINGS.LANGUAGE' | translate }}</div>
          </div>
        </a>
        <a [routerLink]="['/app', 'settings', 'calendar']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
            <div class="label">{{ 'SETTINGS.CALENDAR' | translate }}</div>
          </div>
        </a>
        <a [routerLink]="['/app', 'settings', 'notifications']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
          <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
            <div class="label">{{ 'SETTINGS.NOTIFICATIONS' | translate }}</div>
          </div>
        </a>

        @if (['ADMIN', 'SUPPORT'].includes(user.role)) {
          <a [routerLink]="['/app', 'settings', 'assistant']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'SETTINGS.ASSISTANT' | translate }}</div>
            </div>
          </a>
          <a [routerLink]="['/app', 'settings', 'transcript']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'SETTINGS.TRANSCRIPT' | translate }}</div>
            </div>
          </a>
          <a [routerLink]="['/app', 'settings', 'minutes-styling']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'SETTINGS.MINUTING' | translate }}</div>
            </div>
          </a>
          <a [routerLink]="['/app', 'settings', 'sharing']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
              <div class="label">{{ 'SETTINGS.SHARING' | translate }}</div>
            </div>
          </a>
          @if (
            user.organization.resolvedSettings.retentionPeriodInDaysForMedia !== null ||
            user.organization.resolvedSettings.retentionPeriodInDaysForDocuments !== null ||
            user.organization.resolvedSettings.retentionPeriodInDaysForTranscript !== null ||
            user.organization.resolvedSettings.retentionPeriodInDaysForCall !== null
          ) {
            <a [routerLink]="['/app', 'settings', 'retention']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
              <div class="navigation-item" routerLinkActive="active" (click)="disableHover()">
                <div class="label">{{ 'SETTINGS.RETENTION' | translate }}</div>
              </div>
            </a>
          }
        }
      </div>
    }
  </div>

  <!-- Fixed bottom section -->
  <div class="bottom-section">
    @if (ongoingCalls$ | async; as result) {
      @if (result.isSuccess) {
        @if (result.data.length > 0) {
          <mat-divider></mat-divider>
          <div class="ongoing-calls-container">
            <div class="ongoing-call-list">
              @for (call of result.data; track call.id) {
                <app-ongoing-meeting-card
                  [call]="call"
                  [isExpanded]="isExpanded"
                  [useHighlight]="false"
                  (menuOpened)="isMenuOpen = true"
                  (menuClosed)="onMenuClosed()"
                ></app-ongoing-meeting-card>
              }
            </div>
          </div>
        }
      }
    }
    <mat-divider></mat-divider>
    <div class="dropdown-menu-container">
      <div class="user-information-container clickable" [matMenuTriggerFor]="menu" (menuOpened)="isMenuOpen = true" (menuClosed)="onMenuClosed()">
        <app-avatar [input]="user | userName" size="small"></app-avatar>
        <div class="name label">{{ user | userName }}</div>
      </div>
      <mat-menu #menu="matMenu">
        @if (user.role === 'SUPPORT') {
          <a [routerLink]="['/app', 'support']" [queryParams]="{ demoProfileId: activeDemoProfile$ | async }">
            <button mat-menu-item translate="COMMON.SUPPORT"></button>
          </a>
          @if (activeDemoProfile$ | async) {
            <a [routerLink]="[]" [queryParams]="{ demoProfileId: null }">
              <button mat-menu-item translate="DEMO_PROFILES.DISABLE"></button>
            </a>
          } @else {
            @if (demoProfiles$ | async; as result) {
              @if (result.isSuccess) {
                @for (profile of result.data; track profile.id) {
                  <a [routerLink]="[]" [queryParams]="{ demoProfileId: profile.id }">
                    <button mat-menu-item translate="DEMO_PROFILES.ACTIVATE_DEMO_PROFILE" [translateParams]="{ name: profile.name }"></button>
                  </a>
                }
              }
            }
          }
        }
        <button mat-menu-item translate="COMMON.SIGN_OUT" (click)="signOut()"></button>
      </mat-menu>
    </div>
  </div>
</div>
